import { Injectable } from '@angular/core';
import { Observable, forkJoin, map, mergeMap } from 'rxjs';
import { PaymentMethodResponse } from '../model/paymentMethodResponse';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppUrlService } from 'src/app/services/app-url.service';
import { PaymentInfo } from '../model/paymentInfo';
import { PaymentRequest } from '../model/paymentRequest';
import { PaymentResponse } from '../model/paymentResponse';
import { SharedStateService } from 'src/app/services/shared-state.service';

@Injectable({
  providedIn: 'root'
})
export class PaysService {

  selectedPM : any | undefined;

  constructor(private http: HttpClient, private appUrls : AppUrlService, private sharedService: SharedStateService) { }

  getlogo(): Observable<Blob> {
    let paymentInfo = this.sharedService.getState('paymentInfo');
    return this.http.get(this.appUrls.getURL("partnerLogo"), { responseType: 'blob' });
  }



  public paymentMethods(paymentInfo:any):Observable<PaymentMethodResponse> {
    return this.http.post<PaymentMethodResponse>(this.appUrls.getURL("paymentMethods"), "{\"amount\":" + paymentInfo.transactionAmount + "}")
  }

  public makePayment(paymentRequest:PaymentRequest):Observable<PaymentResponse> {
    return this.http.post<PaymentResponse>(this.appUrls.getURL("makePayment"), paymentRequest);
  }

  public orderReceipt():Observable<PaymentResponse> {
    let orderId = this.sharedService.getState('orderId');
    return this.http.post<PaymentResponse>(this.appUrls.getURL("orderReceipt")+orderId, null);
  }

  public appleValidation(body: any): Observable<any> {
    let httpHeaders = new HttpHeaders();
    
    httpHeaders = httpHeaders.set('Content-Type','application/json'); 
    let options = { headers: httpHeaders}; 
    return this.http.post<any>(this.appUrls.getURL("appleValidation"), body, options);
  } 

}
